import { render, staticRenderFns } from "./CompanyDetailsCard.vue?vue&type=template&id=d8ef5718"
import script from "./CompanyDetailsCard.vue?vue&type=script&lang=ts"
export * from "./CompanyDetailsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports